import React from "react";

const DotsAboutM = () => (
  <svg width="261" height="182" viewBox="0 0 261 182" fill="none" xmlns="http://www.w3.org/2000/svg">
<g style={{mixBlendMode: "difference"}}>
<path className="st0" d="M10.6,6.4c-0.2,2.2-2.1,3.9-4.3,3.7l0,0C4.1,9.9,2.4,8,2.6,5.8s2.1-3.9,4.3-3.7l0,0C9.1,2.3,10.8,4.2,10.6,6.4z
  " fill="#FFFFFF" />
<path className="st0" d="M43,11.1c0.5-2.2,2.6-3.5,4.8-3.1l0,0c2.2,0.5,3.5,2.6,3.1,4.8c-0.5,2.2-2.6,3.5-4.8,3.1l0,0
  C43.9,15.4,42.5,13.3,43,11.1z" fill="#FFFFFF" />
<path className="st0" d="M82.2,22c0.8-2.1,3.1-3.1,5.1-2.4l0,0c2.1,0.8,3.1,3.1,2.4,5.1s-3.1,3.1-5.1,2.4l0,0
  C82.5,26.4,81.4,24.1,82.2,22z" fill="#FFFFFF" />
<path className="st0" d="M119.5,38.4c1.1-1.9,3.5-2.7,5.4-1.6l0,0c1.9,1.1,2.7,3.5,1.6,5.4c-1.1,1.9-3.5,2.7-5.4,1.6l0,0
  C119.2,42.7,118.5,40.3,119.5,38.4z" fill="#FFFFFF" />
<path className="st0" d="M154.2,59.7c1.3-1.8,3.8-2.2,5.6-0.9l0,0c1.8,1.3,2.2,3.8,0.9,5.6c-1.3,1.8-3.8,2.2-5.6,0.9l0,0
  C153.3,64,152.9,61.5,154.2,59.7z" fill="#FFFFFF" />
<path className="st0" d="M185.6,85.6c1.5-1.6,4.1-1.6,5.7-0.1l0,0c1.6,1.5,1.6,4.1,0.1,5.7s-4.1,1.6-5.7,0.1l0,0
  C184.1,89.7,184.1,87.2,185.6,85.6z" fill="#FFFFFF" />
<path className="st0" d="M213.1,115.7c1.8-1.3,4.3-1,5.6,0.7l0,0c1.3,1.8,1,4.3-0.7,5.6c-1.8,1.3-4.3,1-5.6-0.7l0,0
  C211,119.5,211.3,117,213.1,115.7z" fill="#FFFFFF" />
<path className="st0" d="M236,149.3c1.9-1.1,4.4-0.4,5.4,1.5l0,0c1.1,1.9,0.4,4.4-1.5,5.4c-1.9,1.1-4.4,0.4-5.4-1.5l0,0
  C233.4,152.8,234.1,150.4,236,149.3z" fill="#FFFFFF" />
<path className="st0" d="M253.9,185.9c2.1-0.8,4.4,0.2,5.2,2.3l0,0c0.8,2.1-0.2,4.4-2.3,5.2c-2.1,0.8-4.4-0.2-5.2-2.3l0,0
  C250.8,189,251.8,186.7,253.9,185.9z" fill="#FFFFFF" />
</g>
</svg>
);

export default DotsAboutM;
